import type { ImmutableArray } from "@/lib/immutable";
import {
	useCheckoutFormState,
	type WarehouseLocation,
} from "../../hooks/useCheckoutFormState";
import { useTranslate } from "../../hooks/useTranslate/useTranslate";
import { Field, FieldLabel } from "../ui/field";
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";
export type SelectLocationProps = {
	disabled?: boolean;
	className?: string;
	required?: boolean;
};
export const SelectLocation: React.FC<SelectLocationProps> = (props) => {
	const checkoutFormState = useCheckoutFormState();
	const translate = useTranslate();
	//const warehouse = checkoutFormState.getWarehouse();
	//const warehouseId = warehouse?.WarehouseId ?? '';

	//const warehouseLocations: ImmutableArray<WarehouseLocation> = (checkoutFormState.get().lookuplocation ?? []).filter(l => l.WarehouseId === warehouseId);
	const warehouseLocations: ImmutableArray<WarehouseLocation> =
		checkoutFormState.get().lookuplocation ?? [];
	const locationCaption = translate("Location");
	let locationid = "";
	//console.log({
	//    warehouseLocations: checkoutFormState.get().lookuplocation
	//})
	if (
		checkoutFormState.get().locationIdValue &&
		(checkoutFormState.get().lookuplocation?.length ?? 0)
	) {
		locationid = checkoutFormState.get().locationIdValue ?? "";
	}
	let value = "";
	if (warehouseLocations.length > 0) {
		const currentWarehouse = warehouseLocations.find(
			(o) => o.LocationId === locationid,
		);
		if (currentWarehouse) {
			value = locationid;
		}
	}

	const items = warehouseLocations.map((w) => {
		return {
			label: w.Location,
			value: w.LocationId,
		};
	});

	return (
		<Field className={`w-full ${props.className ?? ""}`.trim()}>
			<FieldLabel htmlFor="location-select">
				{locationCaption}{" "}
				{props.required && <span className="text-destructive">*</span>}
			</FieldLabel>
			<Select
				id="location-select"
				disabled={props.disabled ?? false}
				required={props.required}
				items={items}
				onValueChange={async (value) => {
					const warehouselocationid = value || "";
					return Promise.resolve().then(() => {
						const warehouselocationparts = warehouselocationid.split("~");
						if (warehouselocationparts.length > 0) {
							const locationid = warehouselocationparts[0];
							checkoutFormState.setLocationId(locationid);
						}
						if (warehouselocationparts.length > 1) {
							const warehouseid = warehouselocationparts[1];
							checkoutFormState.setWarehouseId(warehouseid);
						}
					});
				}}
				value={value}
			>
				<SelectTrigger className="w-full">
					<SelectValue />
				</SelectTrigger>
				<SelectContent>
					<SelectGroup>
						{warehouseLocations.map((location) => {
							let locationName = location.Location;
							if (location.Warehouse !== location.Location) {
								locationName += ` (${location.Warehouse})`;
							}
							return (
								<SelectItem
									key={location.LocationId}
									value={location.LocationId}
								>
									{locationName}
								</SelectItem>
							);
						})}
					</SelectGroup>
				</SelectContent>
			</Select>
		</Field>
	);
};
